import { PurchaseButtonLink } from "@/components/Buttons/index";
import FormatWatchPrice from "@/components/FormatWatchPrice";
import RightViewTerm from "@/components/RightViewTerm";
import { useDeviceInfoQuery } from "@/hooks";
import config from "@/lib/config";
import routes from "@/lib/routes";
import styles from "@/styles/Video.module.scss";
import Image from "next/legacy/image";
import Link from "next/link";
import { useMemo } from "react";

export default function ProductInfo({ withLink, product, rights, isLoggedIn }) {
  const right = useMemo(() => {
    if (!product.rightIds) return null;
    return rights.find((right) =>
      product.rightIds.includes(parseInt(right.id, 10))
    );
  }, [product, rights]);

  const { data: { deviceInfo } = {} } = useDeviceInfoQuery({
    fetchPolicy: "cache-first",
  });

  const discountPrice = right?.discount_price;
  const discountFlag = right?.discount_price > 0;

  return (
    <>
      <div className={styles.product}>
        <div className={styles.productInner}>
          <div className={styles.image}>
            {product?.thumbnailUrl && (
              <Image
                src={product.thumbnailUrl}
                alt={product.name}
                width={320}
                height={180}
                layout="responsive"
              />
            )}
          </div>
          <div className={styles.info}>
            <h4 className={styles.name}>{product.name}</h4>
            <div className={styles.price}>
              <FormatWatchPrice
                price={product.price}
                type="tvod"
                isLoggedIn={isLoggedIn}
                discountPrice={discountPrice}
                discountFlag={discountFlag}
              />
            </div>
            <div className={styles.rightViewLimit}>
              <RightViewTerm right={right} />
            </div>
            <div className={styles.description}>{product.description}</div>
            {withLink && (
              <div className={`${styles.link} ${styles.isDesktop}`}>
                <PurchaseButtonLink product={product} large />
              </div>
            )}
          </div>
        </div>
        {withLink && (
          <div className={`${styles.link} ${styles.isNotDesktop}`}>
            <PurchaseButtonLink product={product} />
          </div>
        )}
      </div>
      <div className={styles.condition}>
        {/*discountFlag && (
          <>
            ※放送契約者向け割引提供金額は
            <Link
              href={routes.campaignWithBroadcast}
              target="_blank"
              rel="noopener noreferrer"
            >
              割引対象一覧
            </Link>
            をご覧ください。
            <br />
            ※割引適用金額となる対象の放送契約解約後は通常金額が適用されます
            <br />
          </>
        )*/}
        ※特定商取引法については
        <Link
          href={routes.legalSctLaw}
          target="_blank"
          rel="noopener noreferrer"
        >
          こちら
        </Link>
        からご確認ください。
        <br />
        {deviceInfo?.isAndroid && (
          <span>
            ※Android端末をご利用の方はブラウザ上ではご視聴できませんので、必ず
            <Link href={config.appStoreUrl.android}>SPOOXアプリ</Link>
            をダウンロードしてご視聴ください。
          </span>
        )}
      </div>
    </>
  );
}
